var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9941 17.9829C18.9941 18.215 18.902 18.4375 18.7379 18.6016C18.5738 18.7657 18.3512 18.8579 18.1191 18.8579H4.11914C3.88708 18.8579 3.66452 18.7657 3.50042 18.6016C3.33633 18.4375 3.24414 18.215 3.24414 17.9829V8.78665C3.24405 8.65332 3.27443 8.52172 3.33297 8.40192C3.3915 8.28211 3.47665 8.17727 3.58189 8.0954L10.5819 2.65115C10.7355 2.53167 10.9245 2.4668 11.1191 2.4668C11.3137 2.4668 11.5028 2.53167 11.6564 2.65115L18.6564 8.0954C18.7616 8.17727 18.8468 8.28211 18.9053 8.40192C18.9639 8.52172 18.9942 8.65332 18.9941 8.78665V17.9829ZM17.2441 17.1079V9.21365L11.1191 4.45015L4.99414 9.21365V17.1079H17.2441ZM6.74414 13.6079H15.4941V15.3579H6.74414V13.6079Z",
    fill: "#EAAC0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.76373d01e3f521bd74d7c48746c8e614.svg";
export { ForwardRef as ReactComponent };